export const ForwardIcon: React.FC<any> = ({ className }) => {
  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{
        __html: `
        <svg
              width="11"
              height="11"
              viewBox="0 0 11 11"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 10L5.5 5.5L1 1"
                stroke="white"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M6 10L10.5 5.5L6 1"
                stroke="white"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
          </svg>
    `,
      }}
    />
  );
};
